/**
 * DEPRECATED-add-step-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Comment, Visibility } from "../../../intake-form/comment";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeprecatedAddStepCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DEP_REQ_ADD_STEP_COMMENT;
	public static tag : MessageTag = MessageTag.DEP_REQ_ADD_STEP_COMMENT;

  public isPublic : boolean = false;
  public groupIds : number [] = [];

  /**
   * Construct a new {@link AddStepCommentRequest}.
   */
  constructor (
    public stepId : number,
    public comment : string,
    visibility : Visibility,
    selfGroupIds : number[]
  )
  {
    super();
    Comment.applyVisibilityToMessage(this, visibility, selfGroupIds);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/DEPRECATED-add-step-comment-request.ts